import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { fetchCompanyProfile } from '../Redux/companySlice';

/**
 * Hook to check if user is authenticated as a brand/company
 * @returns {Object} { isBrand, isAuthenticated, company }
 */
export const useBrandAuthCheck = () => {
  const dispatch = useDispatch();
  const company = useSelector((state) => state.company.company);
  const isAuthenticated = useSelector((state) => state.company.isAuthenticated);
  const loading = useSelector((state) => state.company.loading);
  const token = localStorage.getItem('token');
  const userType = localStorage.getItem('userType');
  const hasFetchedRef = useRef(false);

  // If we have a company token but no company data in Redux, fetch it once
  useEffect(() => {
    if (token && userType === 'company' && !company && !loading && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      dispatch(fetchCompanyProfile()).finally(() => {
        hasFetchedRef.current = false;
      });
    }
  }, [token, userType, company, loading, dispatch]);

  // Reset ref if token or userType changes
  useEffect(() => {
    if (!token || userType !== 'company') {
      hasFetchedRef.current = false;
    }
  }, [token, userType]);

  // Check if user is a brand - must have token, correct userType, and company data
  const isBrand = !!(token && userType === 'company' && company);
  const isInfluencer = !!(token && userType === 'influancer');

  return {
    isBrand,
    isInfluencer,
    isAuthenticated: isBrand && isAuthenticated,
    company,
    token,
    userType,
  };
};
